// 组件

require('./lib/util/object-assign');
require('./lib/util/promise');
// 基本工具模块
require('./lib/util/base');
// 对数字处理
require('./lib/util/number'); 
// 对时间处理
require('./lib/util/date');
// 对图片处理
require('./lib/util/img');
// 对直播级别处理
require('./lib/util/grade');
// 路由
require('./lib/route');
// 筛选组件
require('./lib/filter');
// 加载
require('./lib/loading');
// 弹出层
require('./lib/poplayer');
// 简单提示
require('./lib/notification');
// 倒计时
require('./lib/timer');
// tab切换
require('./lib/tabview');
// 全部刷新
require('./lib/refresh');
// 语言包
require('./lang/index');


// 业务模块 
require('./component/api');
require('./component/app');
require('./component/hostlist'); // 主播榜单
require('./component/send-hostlist'); // 土豪榜
require('./component/send-userlist'); // 主播守护榜



// WEBPACK FOOTER //
// ./js/seed.js